// ABOUTME: Decoders for GET /aep/:uuid/license_offers (DVLP-7860).
// ABOUTME: The three text fields and the icon are Monby Maybes; highlights is a plain array.
import { explicitMaybe } from '@execonline-inc/decoders';
import { Decoder, array, boolean, dateISO, field, number, string, succeed } from 'jsonous';
import { linkDecoder, resourceDecoder } from '../../../../Resource/Decoders';
import { licenseCommerceTypeDecoder } from '../../SharedOpenEnrollment/SharedInvitationResourceStore/Decoders';
import { LicenseOffer, LicenseOffers, LicenseOffersResource } from './Types';

export const licenseOfferDecoder: Decoder<LicenseOffer> = succeed({})
  .assign('productLicenseTypeId', field('product_license_type_id', number))
  .assign('name', field('name', string))
  .assign('description', field('description', explicitMaybe(string)))
  .assign(
    'includesFollowingContentHeader',
    field('includes_following_content_header', explicitMaybe(string)),
  )
  .assign(
    'includesFollowingContentDescription',
    field('includes_following_content_description', explicitMaybe(string)),
  )
  .assign('whoIsItFor', field('who_is_it_for', explicitMaybe(string)))
  .assign('highlights', field('highlights', array(string)))
  .assign('badgeLabel', field('badge_label', explicitMaybe(string)))
  .assign('iconUrl', field('icon_url', explicitMaybe(string)))
  .assign('coveredProgramFamilyIds', field('covered_program_family_ids', array(number)))
  .assign('startsOn', field('starts_on', dateISO))
  .assign('endsOn', field('ends_on', dateISO))
  .assign('priceInCents', field('price_in_cents', number))
  .assign('currency', field('currency', string))
  .assign('links', field('links', array(linkDecoder)));

export const licenseOffersDecoder: Decoder<LicenseOffers> = succeed({})
  .assign('licenseCommerceType', field('license_commerce_type', licenseCommerceTypeDecoder))
  .assign('programId', field('program_id', explicitMaybe(number)))
  .assign('hasLicenseEntitlement', field('has_license_entitlement', boolean))
  .assign('courseCount', field('course_count', number))
  .assign('receiptEmail', field('receipt_email', string))
  .assign('offers', field('offers', array(licenseOfferDecoder)));

export const licenseOffersResourceDecoder: Decoder<LicenseOffersResource> =
  resourceDecoder(licenseOffersDecoder);
